import React, { Component, Fragment } from "react";
import CustomForm from "../../../libraries/form";
import { CRUDFunction } from "../../../reduxCURD/container";
import SpinnerLoader from "../../Common/SpinnerLoader";
import UISectionHeader from "../../Common/UISectionHeader";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import { hosSearchFiltersFormSchema } from "./schemas/hosSearchFiltersFormSchema";
import { userListByGroupRequest, userListRequest } from "../../../reduxRelated/actions/userActions";
import { ToastService } from "../../../utils/toastify";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import _ from "lodash";
import { dataFormatters } from "../../../utils/dataFormatters";
import TopMessageBar from "../../../libraries/TopMessageBar";
import SvgIcon from "react-icons-kit";
import { printer } from "react-icons-kit/icomoon/printer";
import "./style.css";
import HosSearchRecordsView from "./HosSearchRecordsView";
import { languageService } from "../../../Language/language.service";
import Pagination from "./PaginationComponent";
import { PillTextButton } from "../../../libraries/GeneralButtons";
import DetailsOfServiceReport from "./DetailsOfServiceReport";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import { getDate } from "../../../utils/dateParser";

export const hosViolationCodes = [
  { issueCode: "1001", issueText: "Exceeded 12 hours of consecutive time on duty." },
  { issueCode: "1002", issueText: "24 hour period served with less than 10 continuous hours off-duty." },
];

class HosReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showloader: false,
      searchFiltersFormSchema: null,
      searchFilters: {},
      searchUser: null,
      users: [],
      selectOptionsLoaded: false,
      searchResult: {
        userEmail: null,
        timezone: null,
        startDate: null,
        endDate: null,
        latestHosRecord: null,
        days: [],
      },
      currentPage: {
        startDate: null,
        endDate: null,
        days: [],
      },
      showFullReport: false,
      singleReport: null,
    };
    this.printReport = this.printReport.bind(this);
    this.setShowLoader = this.setShowLoader.bind(this);
    this.searchRecords = this.searchRecords.bind(this);
    this.compileSearchHosRecordsFormSchema = this.compileSearchHosRecordsFormSchema.bind(this);
    this.getArrayfromPaginationComponent = this.getArrayfromPaginationComponent.bind(this);
    this.setSingleReportView = this.setSingleReportView.bind(this);
    this.backBtn = this.backBtn.bind(this);
    this.loadUrlSearchFormParams = this.loadUrlSearchFormParams.bind(this);
    this.scrollToSearchRecords = this.scrollToSearchRecords.bind(this);
  }

  scrollToSearchRecords() {
    window.scrollTo({ top: 350, behavior: "smooth" });
  }
  // for state retention
  loadUrlSearchFormParams() {
    // load previous search params for state retention
    const { stateRetention } = this.props;

    if (this.props.stateRetention.searchFilters) {
      const searchParams = new URLSearchParams(stateRetention.searchFilters);
      let prevFormData = {
        employeeEmail: searchParams.get("employeeEmail"),
        activityTypeCode: searchParams.get("activityTypeCode"),
        startDate: getDate(searchParams.get("startDate")),
        endDate: getDate(searchParams.get("endDate")),
        viewNonCompliantRecords:
          searchParams.get("viewNonCompliantRecords") == true || searchParams.get("viewNonCompliantRecords") === "true" ? true : false,
        violations: searchParams.get("violations") ? searchParams.get("violations").split(",") : [],
      };
      this.setState({
        showFullReport: this.props.stateRetention.showFullReport ? true : false,
      });
      this.searchRecords({ fields: prevFormData }, true);
    }
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }

  componentDidMount() {
    // Fetch All Users
    this.props.userListRequest();
  }

  compileSearchHosRecordsFormSchema(userSelectOptions) {
    const { getAllActivityTypeSelectOptions } = this.context;

    let formSchema = updateShortSchema(_.cloneDeep(hosSearchFiltersFormSchema), {
      // timezone: {
      //   selectOptions: TIMEZONE_SELECT_OPTIONS,
      // },
      employeeEmail: {
        selectOptions: userSelectOptions,
      },
      activityTypeCode: {
        selectOptions: getAllActivityTypeSelectOptions("Off Duty"),
      },
      violations: {
        selectOptions: [
          { val: "", text: languageService("Select") },
          ...hosViolationCodes.map((violation) => ({ val: violation.issueCode, text: violation.issueText })),
        ],
      },
    });
    return formSchema;
  }

  componentDidUpdate(prevProps) {
    const { actionType, userActionType, HosReport, userList } = this.props;
    if (userActionType !== prevProps.userActionType) {
      if (userActionType === "USER_LIST_REQUEST") {
        this.setShowLoader(true);
      } else if (userActionType === "USER_LIST_SUCCESS") {
        // save select options for users
        if (Array.isArray(userList)) {
          const userSelectOptions = [
            { val: "", text: languageService("Select") },
            ...userList
              .sort((a, b) => a.name.localeCompare(b.name))
              .filter((user) => user.HosInfo && user.HosInfo.startDate && user.HosInfo.timezone)
              .map((user) => ({ val: user.email, text: `${user.name} (${user.email})` })),
          ];
          this.setState(
            {
              users: [...userList],
              searchFiltersFormSchema: this.compileSearchHosRecordsFormSchema(userSelectOptions),
            },
            () => this.loadUrlSearchFormParams(),
          );
        }
        this.setShowLoader(false);
      } else if (userActionType === "USER_LIST_FAILURE") {
        this.setShowLoader(false);
      }
    }

    if (actionType !== prevProps.actionType) {
      if (actionType === "HOSREPORT_READ_REQUEST") {
        this.setShowLoader(true);
      } else if (actionType === "HOSREPORT_READ_SUCCESS") {
        // todo: validate expected response
        this.setState({
          searchResult: HosReport && Array.isArray(HosReport.days) ? HosReport : {},
        });

        this.setShowLoader(false);
      } else if (actionType === "HOSREPORT_READ_FAILURE") {
        this.setShowLoader(false);
      }
    }
  }

  printReport() {
    // document.title = "Details of Service";
    window.print();
  }

  searchRecords(submission, loadPrevState = false) {
    const { getHosReport } = this.props;
    const { users, singleReport } = this.state;
    const { employeeEmail } = submission.fields;
    const user = users.find((u) => u.email === employeeEmail);
    // reset search results
    this.setState({
      searchUser: null,
      searchResult: {
        userEmail: null,
        timezone: null,
        startDate: null,
        endDate: null,
        latestHosRecord: null,
        days: [],
      },
    });

    if (!user || !user.HosInfo || !user.HosInfo.startDate || !user.HosInfo.timezone) {
      ToastService.Error(`${languageService("Error")}: `, languageService("User is not configured for HOS."));
      return;
    }
    this.setState(
      {
        searchFilters: _.cloneDeep(submission.fields),
        searchUser: user,
      },
      () => singleReport && this.backBtn(),
    );
    let filters = JSON.parse(JSON.stringify(submission.fields));

    filters.timezone = user.HosInfo.timezone;
    filters.activityTypeCode = filters.activityTypeCode ? filters.activityTypeCode : "";
    filters.startDate && (filters.startDate = dataFormatters.getMomentDateInDifferentTimezone(filters.startDate, filters.timezone));
    filters.endDate && (filters.endDate = dataFormatters.getMomentDateInDifferentTimezone(filters.endDate, filters.timezone));

    if (filters.startDate && filters.endDate && filters.startDate.isAfter(filters.endDate)) {
      ToastService.Error(`${languageService("Error")}: `, languageService("Search period start date should not be after the end date."));
      return;
    }
    filters = JSON.parse(JSON.stringify(filters));
    const searchQueryString = `?${new URLSearchParams(filters)}`;

    if (!loadPrevState) {
      // loading previous state.
      this.props.stateRetention.set("searchFilters", searchQueryString);
    }
    // search hos data records given the criteria
    getHosReport && getHosReport(`entry/fullsearch/${searchQueryString}`);
  }

  getArrayfromPaginationComponent(firstIndex, lastIndex) {
    const { searchResult } = this.state;
    const slicedArray = searchResult.days.slice(firstIndex, lastIndex);
    if (slicedArray.length > 0) {
      const [firstDate, ...firstRest] = slicedArray;
      const [lastDate, ...lastRest] = slicedArray.reverse();
      this.setState({ currentPage: { startDate: firstDate.date, endDate: lastDate.date, days: slicedArray.reverse() } });
    } else {
      // if
      this.setState({ currentPage: { startDate: searchResult.startDate, endDate: searchResult.endDate, days: [] } });
    }
  }
  setSingleReportView(showReport) {
    this.setState({
      singleReport: showReport,
    });
  }
  backBtn() {
    this.setState({
      singleReport: null,
    });
  }
  render() {
    const { searchFiltersFormSchema, currentPage, singleReport } = this.state;
    const { searchFilters, searchResult, searchUser, showFullReport } = this.state;

    const showSearchResults =
      searchResult.timezone && searchResult.startDate && searchResult.endDate && Array.isArray(searchResult.days) && searchUser
        ? true
        : false;
    return (
      <div>
        <div className="no-print">
          <UISectionHeader title={languageService("Search HOS Reports")} />
          <SpinnerLoader spinnerLoading={this.state.showloader} />
          {searchFiltersFormSchema && (
            <CustomForm
              hideFormTitle={true}
              mode="inline"
              fieldsData={searchFilters}
              formSchema={searchFiltersFormSchema}
              parentRef={{
                searchRecords: this.searchRecords,
              }}
            />
          )}
        </div>
        {singleReport ? (
          <Fragment>
            <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
              <div
                className="report-arrow"
                style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                onClick={(e) => {
                  this.backBtn();
                }}
              >
                <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Back")}
                </span>
                <SvgIcon icon={arrowLeft} size={24} />
              </div>
              <div
                className="report-print"
                style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                onClick={(e) => {
                  this.printReport();
                }}
              >
                <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Print Report")}
                </span>
                <SvgIcon icon={printer} size={24} />
              </div>
            </div>
            <TopMessageBar
              message={`${languageService("Showing report for")} ${dataFormatters.dateFormatterWithTimezone(singleReport.day.date)}.`}
              type={"Info"}
            />
            <div className="print" style={{ overflowX: "auto" }}>
              <DetailsOfServiceReport {...singleReport} showPriorTimeOff={true} />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {!singleReport && (
              <UISectionHeader
                title={languageService("Results")}
                className={"no-print"}
                postTitleContent={
                  showSearchResults &&
                  searchResult.days.length && (
                    <Fragment>
                      <PillTextButton
                        title={showFullReport ? languageService("Summary") : languageService("Reports")}
                        onClick={() => {
                          this.setState({
                            showFullReport: !showFullReport,
                          });
                          this.props.stateRetention.set("showFullReport", !showFullReport);
                          this.scrollToSearchRecords();
                        }}
                      />
                      {showFullReport && (
                        <div
                          className="report-print"
                          style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                          onClick={this.printReport}
                        >
                          <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                            {languageService("Print Report")}
                          </span>
                          <SvgIcon icon={printer} size={24} />
                        </div>
                      )}
                    </Fragment>
                  )
                }
              />
            )}
          </Fragment>
        )}
        {showSearchResults && (
          <Fragment>
            {searchResult.days.length === 0 ? (
              <TopMessageBar message={`${languageService("No records found")}!`} type={"Info"} />
            ) : (
              <Pagination
                callBack={this.getArrayfromPaginationComponent}
                recordsPerPage={30}
                noOfRecords={searchResult.days.length}
                hide={singleReport}
              >
                <TopMessageBar
                  message={`${languageService("Showing")} ${currentPage.days.length} ${languageService(
                    "records from",
                  )} ${dataFormatters.dateFormatterWithTimezone(currentPage.startDate)} ${languageService(
                    "to",
                  )} ${dataFormatters.dateFormatterWithTimezone(currentPage.endDate)}.`}
                  type={"Info"}
                />

                <HosSearchRecordsView
                  days={currentPage.days}
                  timezone={searchResult.timezone}
                  user={searchUser}
                  latestHosRecord={searchResult.latestHosRecord}
                  showFullReport={showFullReport}
                  setSingleReportView={this.setSingleReportView}
                />
              </Pagination>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

HosReport.contextType = FixedAppLookupsContext;

let variableList = {
  userReducer: {
    userList: [],
    userListByGroup: [],
  },
};
let reducers = ["userReducer"];

let actionOptions = {
  read: true,
  others: { userListRequest, userListByGroupRequest },
};

const HosReportContainer = CRUDFunction(HosReport, "HosReport", actionOptions, variableList, reducers, "hoursofservice");

export default HosReportContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosReport/index.jsx